import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let ProductInventory = class ProductInventory extends Vue {
    constructor(props) {
        super(props);
        this.snackbar = new CBcSnackbar();
        this.searchOptions = {};
        this.pagination = {
            pageCount: 1,
            pageNow: 1,
            pageArr: [5, 10, 20, 50, '所有'],
            everyPageCount: 10,
            sumDetail: 0,
        };
        this.headers = [
            {
                text: '合同编号',
                align: 'left',
                sortable: false,
                value: 'contractNumber',
                width: '110',
            },
            {
                text: '项目名称',
                align: 'left',
                sortable: false,
                value: 'projectName',
                width: '120',
            },
            {
                text: '合同名称',
                align: 'left',
                sortable: false,
                value: 'contractName',
                width: '160',
            },
            {
                text: '甲方名称',
                align: 'left',
                sortable: false,
                value: 'partyAName',
            },
            // {
            //   text: "甲方地址",
            //   align: "left",
            //   sortable: false,
            //   value: "partyAAddress",
            //   width: "180",
            // },
            {
                text: '甲方代表',
                align: 'left',
                sortable: false,
                value: 'partyARepName',
            },
            {
                text: '乙方名称',
                align: 'left',
                sortable: false,
                value: 'partBName',
            },
            {
                text: '乙方代表',
                align: 'left',
                sortable: false,
                value: 'partyBRepName',
            },
            {
                text: '签订日期',
                align: 'left',
                sortable: false,
                value: 'signingDate',
                width: '115',
            },
            {
                text: '合同总额',
                align: 'left',
                sortable: false,
                value: 'totalAmount',
                width: '120',
            },
            {
                text: '付款时间',
                align: 'left',
                sortable: false,
                value: 'paymentTime',
                width: '115',
            },
            {
                text: '出库单',
                align: 'center',
                sortable: false,
                value: 'orderCount',
                width: '90',
            },
            {
                text: '合同状态',
                align: 'center',
                sortable: false,
                value: 'contractStatus',
                width: '90',
            },
            {
                text: '操作',
                align: 'center',
                sortable: false,
                value: 'action',
                width: '140',
            },
        ];
        this.desserts = [];
        this.dialogContract = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.listHospital = []; // 医院信息
        this.productList = []; // 产品集合
        // 初版订单状态根据确认人信息进入对应的状态，原则上是需要制单人手动提交一次才能进入下一阶段，并且下一阶段不允许修改，初版先不做限制
        this.orderStatusArray = [
            {
                value: 0,
                label: '待提交',
                color: '#607d8b',
            },
            {
                value: 1,
                label: '正常',
                text: '正常',
                color: '#00BCD4',
            },
            {
                value: 2,
                label: '到期',
                color: '#FF9800',
            },
            {
                value: 3,
                label: '作废',
                color: '#ff5252',
            },
        ];
        // 变量在构造函数内部进行声名赋值
        const that = this;
    }
    /**
     * 保存日期时间
     * @param inputType
     */
    handleDateTimeSelection(inputType) {
        const that = this;
        const selectedDate = that.dialogContract.formData[`${inputType}SelectedDate`];
        const selectedTime = that.dialogContract.formData[`${inputType}SelectedTime`];
        if (selectedDate && selectedTime) {
            that.dialogContract.formData[inputType] = `${selectedDate} ${selectedTime}:00`;
            that.dialogContract.formData[`${inputType}Menu`] = false; // 关闭选择器菜单
        }
    }
    /**
     * 添加产品容器
     */
    addProductContainer() {
        const that = this;
        if (that.dialogContract.products.length > 0) {
            // 判断是否有为空的产品容器
            if (that.dialogContract.products.findIndex((o) => (o.productInfoId || '').length == 0) > -1) {
                that.snackbar.warn('请先填写完毕后增加产品.');
                return;
            }
        }
        that.dialogContract.products.push({
            purchaseContractId: '',
            productInfo: '',
            productInfoId: '',
            productName: '',
            brand: '',
            model: '',
            quantity: '0',
            quantityUnit: '',
            price: '0',
            priceUnit: '',
            total: '0',
            totalUnit: '',
            remark: '',
        });
    }
    /**
     * 删除产品容器
     */
    delProductContainer(index) {
        const that = this;
        that.dialogContract.products.splice(index, 1);
    }
    /**
     * 保存合同登记
     * @param isDraft 是否保存为草稿
     */
    async savePurchaseContract(isDraft = false) {
        const that = this;
        if (!(that.dialogContract.operType === 'del')
            && !that.$refs['refFormPro'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogContract.loading = true;
        const form = {
            ...that.dialogContract.formData,
            products: that.dialogContract.products || [],
        };
        let month = '';
        let url = '/api/erp/order/purchase/contract';
        let msg = '';
        // 添加
        if (that.dialogContract.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogContract.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogContract.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        else if (that.dialogContract.operType == 'apply') {
            // 一定要关联产品
            if ((that.dialogContract.products || []).length === 0) {
                that.snackbar.warn('请修改合同关联产品.');
                that.dialogContract.loading = false;
                return;
            }
            // 出库单申请时
            await that.outboundApply(form, isDraft);
            return true;
        }
        await that.axios[month](url, form)
            .then((res) => {
            that.dialogContract.loading = false;
            // 提示成功刷新页面
            that.dialogContract.visible = false;
            that.snackbar.success(`${msg}合同信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogContract.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${msg}合同信息错误${resMeg}`);
            console.log(`${msg}合同信息错误`, e);
        });
    }
    /**
     * 出库单申请
     */
    async outboundApply(formData, isDraft) {
        const that = this;
        const productArray = [];
        // 处理产品信息
        formData.products.forEach((pro) => {
            const outPro = {
                outboundOrderId: '',
                productInfoId: pro.productInfo.id,
                productName: pro.productInfo.productName,
                model: pro.productInfo.model,
                specifications: pro.productInfo.specifications,
                quantity: pro.quantity,
                quantityUnit: pro.quantityUnit,
                remark: '',
            };
            productArray.push(outPro);
        });
        // 验证库存信息 存草稿时不过库存校验
        if (!isDraft && !(await that.verifyProductInventory(productArray))) {
            that.dialogContract.loading = false;
            return false;
        }
        const orderForm = {
            dingtalkItemId: formData.dingtalkItemId,
            hospitalId: formData.hospitalId,
            purchaseContractId: formData.id,
            customerInfoId: formData.customerInfoId,
            customerName: formData.contractName,
            arrivalDate: formData.arrivalTime,
            orderType: '销售',
            orderNumber: that.generateOrderNo(),
            description: `通过合同${formData.contractNumber}生成出库单`,
            applicant: (that.userInfo || {}).userName,
            applicationDate: new Date().format('yyyy-MM-dd'),
            remark: `通过合同${formData.contractNumber}生成出库单`,
            products: productArray,
            isDraft: isDraft,
        };
        // 生成出库单
        await that.axios
            .post('/api/erp/order/outbound', orderForm)
            .then((res) => {
            that.dialogContract.loading = false;
            // 提示成功刷新页面
            that.dialogContract.visible = false;
            that.snackbar.success('生成出库单成功');
            that.getDataList();
        })
            .catch((e) => {
            that.dialogContract.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`生成出库单错误${resMeg}`);
            console.log('生成出库单错误', e);
        });
    }
    /**
     * 验证产品库存信息
     */
    async verifyProductInventory(products) {
        // 获取产品库存
        const that = this;
        try {
            const res = await that.axios.get('/api/erp/inventory/statistics', {
                params: {
                    productIds: products.map(item => item.productInfoId).join(','),
                },
            });
            const resultData = (res.data && res.data.result) || [];
            for (let index = 0; index < products.length; index++) {
                const pro = products[index];
                const inventory = resultData.find((item) => item.id === pro.productInfoId);
                if (pro.quantity > inventory.usableInventory) {
                    // 库存不足，不会生成出库单
                    that.snackbar.error(`产品${pro.model}所需${pro.quantity} ${inventory.unit}，库存仅剩${inventory.usableInventory} ${inventory.unit}，无法生成出库单，您可选择保存为出库单草稿`);
                    return false;
                }
            }
            return true;
        }
        catch (e) {
            console.log(e);
            that.snackbar.error('库存校验错误，请刷新后重试');
            return false;
        }
    }
    /**
     * 生成订单编号
     */
    generateOrderNo() {
        const that = this;
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const prefix = 'XS';
        const randomNumber = Math.floor(Math.random() * 100000)
            .toString()
            .padStart(5, '0');
        const orderNumber = `${prefix}-${year}${month}${day}${randomNumber}`;
        return orderNumber;
    }
    async showContractClick(operType, row) {
        const that = this;
        that.dialogContract.operType = operType;
        that.dialogContract.formData = Object.assign({}, row || {});
        that.dialogContract.products = [];
        // 添加
        async function addFunc() {
            that.dialogContract.title = '新增合同登记';
        }
        // 修改
        async function editFunc() {
            that.dialogContract.title = '修改合同信息';
            // 查看合同绑定产品
            that.dialogContract.products = await that.getContractProduct(Number(that.dialogContract.formData.id));
            if (that.dialogContract.products.length > 0) {
                that.dialogContract.products.forEach((item) => {
                    item.productInfo = that.productList.find((e) => e.id == item.productInfoId);
                });
            }
        }
        // 删除
        async function delFunc() {
            that.dialogContract.title = '删除合同信息';
        }
        // 明细
        async function detailFunc() {
            await editFunc();
            that.dialogContract.title = '查看合同信息';
        }
        // 生成出库单申请
        async function applyFunc() {
            await editFunc();
            that.dialogContract.title = '出库单申请确认';
        }
        if (operType === 'add') {
            await addFunc();
        }
        else if (operType === 'edit') {
            await editFunc();
        }
        else if (operType === 'detail') {
            await detailFunc();
        }
        else if (operType === 'apply') {
            await applyFunc();
        }
        else {
            await delFunc();
        }
        that.dialogContract.visible = true;
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return (that.dialogContract.operType === 'apply'
            || that.dialogContract.operType === 'detail'
            || that.dialogContract.operType === 'sign');
    }
    getOrderStatusOption(contractStatus) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == contractStatus);
        return option || {};
    }
    /**
     * 查询
     */
    async searchChange() {
        const that = this;
        clearTimeout(that.searchOptions.timer);
        that.searchOptions.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    async getDataList() {
        const that = this;
        that.loading = true;
        try {
            const res = await that.axios.get('/api/erp/order/purchase/contract', {
                params: {
                    page: that.pagination.pageNow,
                    limit: typeof that.pagination.everyPageCount === 'number'
                        ? that.pagination.everyPageCount
                        : that.pagination.sumDetail,
                    keyword: that.searchOptions.keyword,
                    hospitalId: that.searchOptions.hospitalId,
                },
            });
            that.desserts = res.data.result || [];
            // 处理签订日期数据
            that.desserts.forEach((item) => {
                if (item.signingDate)
                    item.signingDate = new Date(item.signingDate).format('yyyy-MM-dd');
            });
            that.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.pagination.everyPageCount) || 1;
            that.pagination.pageCount = pageCount;
            if (that.pagination.pageNow > pageCount) {
                that.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.loading = false;
        }
    }
    // 医院列表
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios
                .get('/api/hospital', { params: { simple: true } })
                .then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    // 产品列表
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/sales');
        that.productList = (res.data && res.data.result) || [];
    }
    /**
     * 获取合同产品列表
     */
    async getContractProduct(purchaseContractId) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/purchase/contract/product', {
            params: {
                purchaseContractId: purchaseContractId,
            },
        });
        return (res && res.data && res.data.result) || [];
    }
    /**
     * 产品发生变更时
     */
    productInfoChange(row) {
        const that = this;
        that.setProductInfo(row.productInfo, row);
    }
    productFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['productName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['model'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['shortName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'] || ''));
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    setProductInfo(productInfo, row) {
        const that = this;
        row.productInfoId = productInfo.id;
        row.productName = productInfo.productName;
        row.model = productInfo.model;
        row.quantityUnit = productInfo.unit;
        row.price = productInfo.price;
        row.priceUnit = productInfo.priceUnit;
        row.totalUnit = productInfo.priceUnit;
        row.brand = '博为';
    }
    /**
     * 监听单价变化
     */
    priceChange(row) {
        const that = this;
        row.total = row.price * row.quantity;
    }
    skipOutbound(row) {
        const that = this;
        if (row.contractNumber) {
            // 跳转出库页面
            this.$router.push({
                name: 'OutboundOrder',
                params: { keyword: row.contractNumber },
            });
        }
    }
    async mounted() {
        const that = this;
        that.getHospitalList();
        that.getProductList();
        await that.getDataList();
    }
};
__decorate([
    Getter
], ProductInventory.prototype, "userInfo", void 0);
ProductInventory = __decorate([
    Component({
        name: 'ProductInventory',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], ProductInventory);
export default ProductInventory;
